import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "../lib/api";

export default function WhatsAppFloat() {
  const message = "Hello RSN Gloves, I'd like a quotation.";
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5A] text-white font-bold px-4 py-3 rounded-full shadow-xl transition-transform hover:-translate-y-0.5"
      aria-label="Quick quote on WhatsApp"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Quick Quote</span>
    </a>
  );
}
